var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconMicroDisabledRed = function SvgIconMicroDisabledRed(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.00073L10.6 10.3867M7.11 4.55973V2.28073C7.11 1.62373 6.601 1.07273 5.932 1.00673C5.262 0.93973 4.65 1.37973 4.517 2.02473M5.8 8.67973V10.3867M4.055 10.3867H7.545M4.49 4.41373V5.69373C4.491 6.21073 4.81 6.67673 5.3 6.87473C5.788 7.07273 6.35 6.96373 6.725 6.59773L4.49 4.41373ZM7.982 7.80573C7.11 8.67573 5.786 8.94073 4.635 8.47573C3.484 8.01173 2.736 6.91073 2.745 5.69373V4.84073L7.982 7.80573ZM8.855 4.84073V5.69373C8.855 5.86973 8.838 6.04573 8.807 6.21873L8.855 4.84073Z",
    stroke: "#FB355D",
    strokeWidth: 0.844,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconMicroDisabledRed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-micro-disabled-red.71cceb80e579bd574ab7bea461537420.svg";